import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { fireGtmEvent } from 'utils/gtm'
import RateTableCtaButton from 'components/RateTableCtaButton'
import WidgetContext from 'components/widget-context'

import styles from './styles.module.scss'

const HeaderCTA = ({ ctaUrl, blank = true, btnText = '2 Min: Check Rates', disclaimerText }) => {
  const widgetContext = useContext(WidgetContext)

  const onClickCta = () => {
    fireGtmEvent('ctaClick', Object.assign(widgetContext))
  }

  return (
    <RateTableCtaButton
      containerClassName={styles.cta}
      btnText={btnText}
      target={blank ? '_blank' : '_self'}
      href={ctaUrl}
      onClick={onClickCta}
      disclaimerText={disclaimerText}
    />
  )
}

HeaderCTA.propTypes = {
  ctaUrl: PropTypes.string.isRequired,
  blank: PropTypes.bool,
  btnText: PropTypes.string,
  disclaimerText: PropTypes.string,
}

export { HeaderCTA as HeaderCTANoHoc }
export default withSnowplowContexts(HeaderCTA)
